function InventoryQrCodeModalCtrl($scope, $uibModalInstance, inventory) {
  $scope.saving = false;

  $scope.inventory = inventory;

  $scope.close = function () {
    $uibModalInstance.close(false);
  };

  $scope.showWrkflowsArticle = function($event) {
    if ($event) $event.preventDefault();

    window.wrkflows.showArticle('1067');
  };
}

InventoryQrCodeModalCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'inventory'
];

export default InventoryQrCodeModalCtrl;



// WEBPACK FOOTER //
// ./src/modals/inventoryQrCode/controller.js